"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATHFINDERS_COLONY_NAMES = exports.COMMUNITY_COLONY_NAMES = exports.OFFICIAL_COLONY_NAMES = void 0;
const ColonyName_1 = require("./ColonyName");
exports.OFFICIAL_COLONY_NAMES = [
    ColonyName_1.ColonyName.CALLISTO,
    ColonyName_1.ColonyName.CERES,
    ColonyName_1.ColonyName.ENCELADUS,
    ColonyName_1.ColonyName.EUROPA,
    ColonyName_1.ColonyName.GANYMEDE,
    ColonyName_1.ColonyName.IO,
    ColonyName_1.ColonyName.LUNA,
    ColonyName_1.ColonyName.MIRANDA,
    ColonyName_1.ColonyName.PLUTO,
    ColonyName_1.ColonyName.TITAN,
    ColonyName_1.ColonyName.TRITON,
];
exports.COMMUNITY_COLONY_NAMES = [
    ColonyName_1.ColonyName.IAPETUS,
    ColonyName_1.ColonyName.MERCURY,
    ColonyName_1.ColonyName.HYGIEA,
    ColonyName_1.ColonyName.TITANIA,
    ColonyName_1.ColonyName.LEAVITT,
    ColonyName_1.ColonyName.VENUS,
    ColonyName_1.ColonyName.PALLAS,
    ColonyName_1.ColonyName.DEIMOS,
];
exports.PATHFINDERS_COLONY_NAMES = [
    ColonyName_1.ColonyName.IAPETUS_II,
];
